import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import style from './QQBarSection.module.css';

const QQBarSection = ({ value, color, label }) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);
  return (<div
    data-tip={label}
    aria-label={label}
    style={{ width: `${value}%` }}
    className={`${style.qqBar} ${style[color]}`}
  />);
};

QQBarSection.propTypes = {
  value: PropTypes.number,
  color: PropTypes.string,
  label: PropTypes.string,
};

export default QQBarSection;
